const initialState = {
  mailUnconfirmed: 0,
  bestpartnerUnconfirmed: 0,
  favoriteNoticeUnconfirmed: 0,
  qaAnswerUnconfirmed: 0,
  paymentTicketSenderUnused: 0,
  paymentTicketReceiverUnseen: 0,
  coupleReception: null,
  coupleRequest: null,
  couple: null,
  datetime: null,
};

export default function reducer(state = initialState, action) {
	if (action.type === 'NOTIFICATION_SET') {
		return {
			mailUnconfirmed: action.payload.mailUnconfirmed,
      bestpartnerUnconfirmed: action.payload.bestpartnerUnconfirmed,
      favoriteNoticeUnconfirmed: action.payload.favoriteNoticeUnconfirmed,
      qaAnswerUnconfirmed: action.payload.qaAnswerUnconfirmed,
      paymentTicketSenderUnused: action.payload.paymentTicketSenderUnused,
      paymentTicketReceiverUnseen: action.payload.paymentTicketReceiverUnseen,
      coupleReception: action.payload.coupleReception,
      coupleRequest: action.payload.coupleRequest,
      couple: action.payload.couple,
      datetime: (new Date()),
		}
	}
  else if (action.type === 'NOTIFICATION_INIT') {
    let newState = Object.assign({}, state);
		newState.datetime = null;
    return newState;
  }
	else {
		return state;
	}
}
